import {
  HTTP_GETSPECIAL_FETCHING,
  HTTP_GETSPECIAL_SUCCESS,
  HTTP_GETSPECIAL_FAILED,
  HTTP_RESET_SPECIAL,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETSPECIAL_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETSPECIAL_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETSPECIAL_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    case HTTP_RESET_SPECIAL:
      return initialState;
    default:
      return state;
  }
};
